export default "__VITE_ASSET__c57fc4c5__"